<template>
  <div class="ms-SearchBox ms-SearchBox--block">
    <input
      class="ms-SearchBox-field"
      type="text"
      :value="value"
      @change="valueChanged"
      @input="valueChanged"
      @blur="$emit('blur', $event)"
      @keyup="$emit('keyup', $event)"
    />
    <label class="ms-SearchBox-label">
      <i class="ms-SearchBox-icon ms-Icon ms-Icon--Search"></i>
      <span class="ms-SearchBox-text">{{ label }}</span>
    </label>
    <div class="ms-CommandButton ms-SearchBox-clear ms-CommandButton--noLabel">
      <button class="ms-CommandButton-button" @click.stop.prevent="clear">
        <span class="ms-CommandButton-icon"><i class="ms-Icon ms-Icon--Clear"></i></span>
        <span class="ms-CommandButton-label"></span>
      </button>
    </div></div
></template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  mounted() {
    new fabric['SearchBox'](this.$el, function() {});
  },
  methods: {
    valueChanged(e) {
      this.$emit('change', e.target.value);
      this.$emit('input', e.target.value);
    },
    clear() {
      this.$emit('change', '');
      this.$emit('input', '');
    }
  }
};
</script>

<style lang="scss" scoped>
.ms-SearchBox {
  &.ms-SearchBox--block {
    width: 100%;

    .ms-SearchBox-field {
      width: inherit;
    }
  }
}
</style>
